module.exports = __webpack_public_path__ + "media/audio35.d887318c.mp3";